import React, { useRef } from 'react'
import SecondHeader from '../../../components/SecondHeader/SecondHeader'
import Footer from '../../../components/Footer/Footer'
import EmployeDashboardSidebar from './EmployeDashboardSidebar'
import DashboardSidebarHeader from '../../../components/corporateSidebar/DashboardSidebarHeader'
import useDashboardSidebarToggle from '../../../hooks/useDashboardSidebarToggle'

const EmployeDashboardLayout = ({ children }) => {
    const sidebarRef = useRef(null);
    const { sidebarOpen, closeSidebar } = useDashboardSidebarToggle(sidebarRef);

    return (
        <>
            <SecondHeader hideMobileNav />
            {sidebarOpen && <div className="dashboard-sidebar-backdrop" onClick={closeSidebar}></div>}
            <div className="container">
                <div className="row mt-4 dashboard-shell-row">
                    <div
                        ref={sidebarRef}
                        className={`col-xl-3 col-lg-3 col-md-4 dashboard-sidebar-col${sidebarOpen ? ' dashboard-sidebar-open' : ''}`}
                    >
                        <DashboardSidebarHeader />
                        <EmployeDashboardSidebar />
                    </div>

                    <div className="col-xl-9 col-lg-9 col-md-8">
                        {children}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default EmployeDashboardLayout